import ISurvey from '../interfaces/ISurvey';
import SurveyAdviceMapping from './SurveyAdviceMapping';
import SurveyChapter from './SurveyChapter';
import SurveyQuestion from './SurveyQuestion';
import SurveyQuestionChapterIntroduction from './SurveyQuestionChapterIntroduction';
import SurveyQuestionIntroduction from './SurveyQuestionIntroduction';
import SurveyQuestionMultipleChoice from './SurveyQuestionMultipleChoice';
import SurveyQuestionNumericInput from './SurveyQuestionNumericInput';
import SurveyQuestionNumericSlider from './SurveyQuestionNumericSlider';
import SurveyQuestionText from './SurveyQuestionText';
import SurveyQuestionType from './SurveyQuestionType';
import SurveyTheme from './SurveyTheme';

class Survey implements ISurvey {
  id: string;

  title: string;

  description: string;

  chapters: SurveyChapter[];

  questions: SurveyQuestion[];

  themes: SurveyTheme[];

  adviceMappings: SurveyAdviceMapping[];

  constructor(
    id: string,
    title: string,
    description: string,
    chapters: SurveyChapter[],
    questions: SurveyQuestion[],
    themes: SurveyTheme[],
    adviceMappings: SurveyAdviceMapping[]
  ) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.chapters = chapters;
    this.questions = questions;
    this.themes = themes;
    this.adviceMappings = adviceMappings;
  }

  public static fromJson(object: any): Survey {
    let surveyQuestions: SurveyQuestion[] = [];

    const chapterList = object.chapters
      .filter(({ showInChapterList }: SurveyChapter) => showInChapterList)
      .map(({ id, title }: SurveyChapter) => ({ id, title }));

    object.chapters.forEach((chapter: SurveyChapter) => {
      const { questions, showIntroPage } = chapter;

      const chapterQuestions = questions.map((question: any) => {
        const { QuestionType } = question;
        switch (QuestionType) {
          case SurveyQuestionType.TEXT:
            return SurveyQuestionText.parse(question);
          case SurveyQuestionType.MULTIPLE_CHOICE:
            return SurveyQuestionMultipleChoice.parse(question);
          case SurveyQuestionType.NUMERIC_INPUT:
            return SurveyQuestionNumericSlider.parse(question);
          case SurveyQuestionType.NUMERIC_SLIDER:
            return SurveyQuestionNumericInput.parse(question);
          case SurveyQuestionType.INTRODUCTION:
            return SurveyQuestionIntroduction.parse(question);
          default:
            throw new Error('This type is not yet supported');
        }
      });

      if (!showIntroPage) {
        const chapterStartQuestion = SurveyQuestionChapterIntroduction.parseFromChapter(chapter, chapterList);
        surveyQuestions = surveyQuestions.concat([chapterStartQuestion, ...chapterQuestions]);
      } else {
        surveyQuestions = surveyQuestions.concat(chapterQuestions);
      }
    });

    const surveyAdviceMappings: SurveyAdviceMapping[] = [];
    object.themes.forEach((theme: SurveyTheme) => {
      theme.adviceMappings.forEach((adviceMapping: SurveyAdviceMapping) => {
        surveyAdviceMappings.push(adviceMapping);
      });
    });

    return new Survey(
      object.id,
      object.title,
      object.description,
      object.chapters,
      surveyQuestions,
      object.themes,
      surveyAdviceMappings
    );
  }
}

export default Survey;
